import { pageIdFromPath } from '~~/layers/config/shared/utils/page-registry';

export default defineNuxtRouteMiddleware((to) => {
	const { isPageEnabled, homePagePath, portalType } = useCustomerConfig();

	// Redirect `/` to the configured home page
	if (to.path === '/' && homePagePath.value) {
		return navigateTo(homePagePath.value, { replace: true });
	}

	const pageId = pageIdFromPath(to.path);

	// Not a registered page (e.g. index/jobs) — always allow
	if (!pageId) return;

	if (!isPageEnabled(pageId)) {
		const log = useAppLogger({ surface: 'page-access' });
		log.warn('page access denied', {
			pageId,
			path: to.path,
			portalType: portalType?.value,
		});
		return navigateTo('/');
	}
});
